export default {"src":"/_next/static/media/shopping_cart_white.5985c584.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};